import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
    idChecklistServico?: number;
    descricao?: string;
};

type Action = {
    setIdChecklistServico: (idChecklistServico: number) => void,
    setDescricao: (descricao?: string) => void,
    clearFilters: () => void
};

export const useChecklistServicoAmbienteListaFilters = create<State & Action>((set) => ({
    descricao: undefined,
    idChecklistServico: undefined,
    setIdChecklistServico: (idChecklistServico) => set({ idChecklistServico }),
    setDescricao: (descricao) => set({ descricao }),
    clearFilters: () => set({
        descricao: undefined,
        idChecklistServico: undefined,
    }),
}));

export const initialChecklistServicoAmbienteFiltersValues: State = {
    descricao: undefined,
    idChecklistServico: undefined,
}